import { RegularGridLegend } from "src/components/legend-item/RegularGridLegend";
import { RegularGridOverlayer } from "src/components/overlayers/RegularGridOverlayer";
import { CaseBufferOverlayer } from "src/components/overlayers/CaseBufferOverlayer";
import type { Overlayer } from "src/types";
import { CaseBufferLegend } from "src/components/legend-item/CaseBufferLegend";

export const GROUPS: { [groupName: string]: Overlayer["group"] } = {
  baseLayers: { name: "baseLayers", type: "radio" },
  result: { name: "result", type: "checkbox" },
  caseConfiguration: { name: "caseConfiguration", type: "checkbox" },
  emissions: { name: "emissions", type: "checkbox" },
  atmostreet: { name: "atmostreet", type: "radio" },
  stations: { name: "stations", type: "checkbox" },
  residentialMaps: { name: "residentialMaps", type: "radio" },
  extraLayers: { name: "extraLayers", type: "checkbox" },
};

export const staticOverlayers: Array<Overlayer> = [
  {
    key: "caseBuffer",
    translationKey: "layer.domain",
    isActive: true,
    opacity: 0.8,
    zIndex: 0,
    component: CaseBufferOverlayer,
    group: GROUPS.caseConfiguration,
    context: ["case-edit", "case-results"],
    layerManager: {
      showFrontLegend: true,
      showBackLegend: false,
      showInLayerManager: true,
    },
    legend: {
      legendType: "component",
      component: () => <CaseBufferLegend />,
    },
  },
  // {
  //   key: "predefinedLEZs",
  //   translationKey: "layer.currentLowEmissionZones",
  //   isActive: true,
  //   opacity: 0.8,
  //   zIndex: 0,
  //   component: PredefinedLEZsOnMap,
  //   group: GROUPS.caseConfiguration,
  //   context: ["case-create"],
  //   layerManager: {
  //     showFrontLegend: true,
  //     showBackLegend: false,
  //     showInLayerManager: true,
  //   },
  //   legend: {
  //     legendType: "component",
  //     component: () => <PredefinedLEZsLegend />,
  //   },
  // },
  {
    key: "modelDomain",
    translationKey: "layer.regularGrid",
    isActive: false,
    opacity: 0.8,
    zIndex: 0,
    component: RegularGridOverlayer,
    group: GROUPS.caseConfiguration,
    context: ["case-edit", "case-results"],
    layerManager: {
      showFrontLegend: true,
      showBackLegend: false,
      showInLayerManager: true,
    },
    legend: {
      legendType: "component",
      component: () => <RegularGridLegend />,
    },
  },
  {
    key: "traffic",
    translationKey: "layer.traffic",
    layers: "atmoplan:genericroad",
    isActive: true,
    opacity: 0.8,
    zIndex: 0,
    group: GROUPS.emissions,
    url: "/geoserver/wms",
    context: ["case-create", "case-edit", "case-results"],
    layerManager: {
      showFrontLegend: true,
      showBackLegend: false,
      showInLayerManager: true,
    },
    legend: { legendType: "wms" },
  },
  {
    key: "pointsources",
    translationKey: "layer.pointsources",
    layers: "atmoplan:genericpointsource",
    isActive: true,
    opacity: 0.8,
    zIndex: 0,
    group: GROUPS.emissions,
    url: "/geoserver/wms",
    context: ["case-create", "case-edit", "case-results"],
    layerManager: {
      showFrontLegend: true,
      showBackLegend: false,
      showInLayerManager: true,
    },
    legend: { legendType: "wms" },
  },
  // {
  //   key: "atmostreet_no2",
  //   translationKey: "layer.atmostreetNo2",
  //   unit: "µg/m³",
  //   layers: "atmostreet_no2",
  //   isActive: false,
  //   opacity: 0.8,
  //   zIndex: 0,
  //   group: GROUPS.atmostreet,
  //   url: "/geoserver/wms",
  //   context: ["case-create", "case-edit", "case-results"],
  //   layerManager: {
  //     showFrontLegend: true,
  //     showBackLegend: false,
  //     showInLayerManager: true,
  //   },
  //   legend: { legendType: "wms" },
  // },
  // {
  //   key: "atmostreet_pm10",
  //   translationKey: "layer.atmostreetPm10",
  //   unit: "µg/m³",
  //   layers: "atmostreet_pm10",
  //   isActive: false,
  //   opacity: 0.8,
  //   zIndex: 0,
  //   group: GROUPS.atmostreet,
  //   url: "/geoserver/wms",
  //   context: ["case-create", "case-edit", "case-results"],
  //   layerManager: {
  //     showFrontLegend: true,
  //     showBackLegend: false,
  //     showInLayerManager: true,
  //   },
  //   legend: { legendType: "wms" },
  // },
  // {
  //   key: "atmostreet_pm25",
  //   translationKey: "layer.atmostreetPm25",
  //   unit: "µg/m³",
  //   layers: "atmostreet_pm25",
  //   isActive: false,
  //   opacity: 0.8,
  //   zIndex: 0,
  //   group: GROUPS.atmostreet,
  //   url: "/geoserver/wms",
  //   context: ["case-create", "case-edit", "case-results"],
  //   layerManager: {
  //     showFrontLegend: true,
  //     showBackLegend: false,
  //     showInLayerManager: true,
  //   },
  //   legend: { legendType: "wms" },
  // },
  // {
  //   key: "stations_no2",
  //   translationKey: "layer.stationsNo2",
  //   layers: "stations_no2",
  //   isActive: false,
  //   opacity: 0.8,
  //   zIndex: 0,
  //   group: GROUPS.stations,
  //   url: "/geoserver/wms",
  //   context: ["case-create", "case-edit", "case-results"],
  //   layerManager: {
  //     showFrontLegend: true,
  //     showBackLegend: false,
  //     showInLayerManager: true,
  //   },
  //   legend: { legendType: "wms" },
  // },
  // {
  //   key: "stations_pm10",
  //   translationKey: "layer.stationsPm10",
  //   layers: "stations_pm10",
  //   isActive: false,
  //   opacity: 0.8,
  //   zIndex: 0,
  //   group: GROUPS.stations,
  //   url: "/geoserver/wms",
  //   context: ["case-create", "case-edit", "case-results"],
  //   layerManager: {
  //     showFrontLegend: true,
  //     showBackLegend: false,
  //     showInLayerManager: true,
  //   },
  //   legend: { legendType: "wms" },
  // },
  // {
  //   key: "stations_pm25",
  //   translationKey: "layer.stationsPm25",
  //   layers: "stations_pm25",
  //   isActive: false,
  //   opacity: 0.8,
  //   zIndex: 0,
  //   group: GROUPS.stations,
  //   url: "/geoserver/wms",
  //   context: ["case-create", "case-edit", "case-results"],
  //   layerManager: {
  //     showFrontLegend: true,
  //     showBackLegend: false,
  //     showInLayerManager: true,
  //   },
  //   legend: { legendType: "wms" },
  // },
];
